import React, {
  Fragment,
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { makeStyles } from "@material-ui/core/styles";

import { useSelected } from "./OrganizeProvider";
import { any, equals } from "ramda";
import { useHistory } from "react-router-dom";
import { notBlank } from "../../util/ext";
import { useSearchParam, isAnyReview } from "./organizeUtil";

// import AddMediaToParentMenu from "../common/AddMediaToParentMenu";
import AddNewModuleDialog from "../modules/browse/AddNewModuleDialog";
import AddOrganizeMediaToParentMenu from "./AddOrganizeMediaToParent";
import NewCollectionDialog from "./sidebar/NewCollectionDialog";

import Divider from "@material-ui/core/Divider";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
  menuContainer: {
    zIndex: "1000",
  },

  menu: {
    borderRadius: "5px",
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    width: "400px",
    overflow: "hidden",
  },

  list: {
    height: "390px",
  },
}));

const initialPosition = {
  mouseX: null,
  mouseY: null,
};

const initialSource = {
  child: null,
  parent: null,
  prevMediaList: null,
};

const initialContext = {
  position: initialPosition,
  setPosition: () => {},
  source: initialSource,
  setSource: () => {},
};

const ContextMenuContext = createContext(initialContext);

const OrganizeContextMenu = props => {
  const history = useHistory();
  const classes = useStyles();

  const { position, source, handleContextMenuClose } = useContext(
    ContextMenuContext,
  );
  const {
    selectedAnthologies,
    selectedCollections,
    selectedContent,
  } = useSelected();

  const [selected, setSelected] = useState([]);
  useEffect(() => {
    if (notBlank(source.child)) {
      if (equals(source.child.mediaType, "content")) {
        setSelected(selectedContent);
      }

      if (equals(source.child.mediaType, "collection")) {
        setSelected(selectedCollections);
      }

      if (equals(source.child.mediaType, "anthology")) {
        setSelected(selectedAnthologies);
      }
    }
  }, [source, selectedAnthologies, selectedCollections, selectedContent]);

  //-- Manage Dialog States
  const [state, setState] = useState({
    newModuleDialog: false,
    newCollectionDialog: false,
    addToCollectionMenu: false,
    addToModuleMenu: false,
  });

  const close = menuItem => {
    setState(prev => ({ ...prev, [menuItem]: false }));
  };

  const open = menuItem => {
    setState(prev => ({ ...prev, [menuItem]: true }));
    // handleContextMenuClose();
  };

  const onSave = ({ mediaType, redirectPath, newModuleId }) => {
    handleContextMenuClose();
    close("newModuleDialog");
    close("newCollectionDialog");
    close("addToCollectionMenu");
    close("addToModuleMenu");

    if (equals(mediaType, "module")) {
      history.push(`/creator/organize?view=module&id=${newModuleId}`);
    } else {
      history.push(redirectPath);
    }
  };

  // const canMoveToAnthology = childMediaType => {
  //   return equals(childMediaType, "collection");
  // };

  const canMoveToCollection = childMediaType => {
    return equals(childMediaType, "content");
  };

  const canMoveToModule = childMediaType => {
    const accetableMedia = ["content", "collection", "anthology"];
    return any(equals(childMediaType, accetableMedia));
  };

  //-- Manage Add to Collection Menu
  const addToCollectionAnchorRef = useRef(null);
  const closeCollectionMenu = event => {
    if (
      addToCollectionAnchorRef.current &&
      addToCollectionAnchorRef.current.contains(event.target)
    ) {
      return;
    }
    close("addToCollectionMenu");
  };

  const prevCollectionMenuOpen = useRef(state.addToCollectionMenu);
  useEffect(() => {
    if (
      prevCollectionMenuOpen.current === true &&
      state.addToCollectionMenu === false
    ) {
      addToCollectionAnchorRef.current.focus();
    }
    prevCollectionMenuOpen.current = state.addToCollectionMenu;
  }, [state.addToCollectionMenu]);

  //-- Manage Add to Module Menu
  const addToModuleAnchorRef = useRef(null);
  const closeModuleMenu = event => {
    if (
      addToModuleAnchorRef.current &&
      addToModuleAnchorRef.current.contains(event.target)
    ) {
      return;
    }
    close("addToModuleMenu");
  };

  const prevModuleMenuOpen = useRef(state.addToModuleMenu);
  useEffect(() => {
    if (
      prevModuleMenuOpen.current === true &&
      state.addToModuleMenu === false
    ) {
      addToModuleAnchorRef.current.focus();
    }
    prevModuleMenuOpen.current = state.addToModuleMenu;
  }, [state.addToModuleMenu]);

  return (
    <Fragment>
      <AddNewModuleDialog
        open={state.newModuleDialog}
        onSave={onSave}
        onClose={() => close("newModuleDialog")}
      />
      <NewCollectionDialog
        open={state.newCollectionDialog}
        onSave={onSave}
        onClose={() => close("newCollectionDialog")}
      />

      <Menu
        keepMounted
        transitionDuration={0}
        open={position.mouseY !== null}
        onClose={handleContextMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={
          position.mouseY !== null && position.mouseX !== null
            ? { top: position.mouseY, left: position.mouseX }
            : undefined
        }
      >
        {notBlank(source.child) && canMoveToCollection(source.child.mediaType) && (
          <div>
            <MenuItem
              ref={addToCollectionAnchorRef}
              onClick={() => open("addToCollectionMenu")}
            >
              Move to Collection
            </MenuItem>
            <Menu
              open={state.addToCollectionMenu}
              onClose={closeCollectionMenu}
              anchorEl={addToCollectionAnchorRef.current}
              // id={`add-to-${parent}-drop-down`}
              // onKeyDown={handleListKeyDown}
              classes={{
                paper: classes.menu,
              }}
              PopoverClasses={{
                root: classes.menuContainer,
              }}
              MenuListProps={{
                classes: {
                  root: classes.list,
                },
              }}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div>
                <AddOrganizeMediaToParentMenu
                  parentType="collection"
                  open={state.addToCollectionMenu}
                  childList={selected}
                  closeMenu={() => close("addToCollectionMenu")}
                  handleAddSuccess={() => {
                    close("addToCollectionMenu");
                    handleContextMenuClose();
                  }}
                />
              </div>
            </Menu>
          </div>
        )}

        {notBlank(source.child) && canMoveToModule(source.child.mediaType) && (
          <div>
            <MenuItem
              ref={addToModuleAnchorRef}
              onClick={() => {
                open("addToModuleMenu");
              }}
            >
              Move to Module
            </MenuItem>
            <Menu
              open={state.addToModuleMenu}
              onClose={closeModuleMenu}
              anchorEl={addToModuleAnchorRef.current}
              // id={`add-to-${parent}-drop-down`}
              // onKeyDown={handleListKeyDown}
              classes={{
                paper: classes.menu,
              }}
              PopoverClasses={{
                root: classes.menuContainer,
              }}
              MenuListProps={{
                classes: {
                  root: classes.list,
                },
              }}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div>
                <AddOrganizeMediaToParentMenu
                  parentType="module"
                  open={state.addToModuleMenu}
                  childList={selected}
                  closeMenu={() => close("addToModuleMenu")}
                  handleAddSuccess={() => {
                    close("addToModuleMenu");
                    handleContextMenuClose();
                  }}
                />
              </div>
            </Menu>
          </div>
        )}

        {/* {notBlank(source.child) &&
          canMoveToAnthology(source.child.mediaType) && (
            <MenuItem>Move to Collection Group</MenuItem>
          )} */}
        <Divider />
        <MenuItem onClick={() => open("newCollectionDialog")}>
          Create New Collection
        </MenuItem>
        <MenuItem onClick={() => open("newModuleDialog")}>
          Create New Module
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

const OrganizeContextMenuProvider = ({ children }) => {
  const [position, setPosition] = useState(initialPosition);
  const [source, setSource] = useState(initialSource);

  const { updateSelectedContextMenuItem } = useSelected();
  const searchParam = useSearchParam();

  const handleContextMenuClick = (event, item) => {
    if (!isAnyReview(searchParam.get("view"))) {
      event.preventDefault();

      if (notBlank(item)) {
        updateSelectedContextMenuItem(item);

        setSource(item);
      }

      setPosition({
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4,
      });
    }
  };

  const handleContextMenuClose = () => {
    setPosition(initialPosition);
    setSource({});
    // removeAllSelected();
  };

  return (
    <ContextMenuContext.Provider
      value={{
        position,
        source,
        handleContextMenuClick,
        handleContextMenuClose,
      }}
    >
      {children}
    </ContextMenuContext.Provider>
  );
};

export { OrganizeContextMenu, OrganizeContextMenuProvider, ContextMenuContext };
